import React, { useEffect } from "react";
import { initializeMetaPixel } from "../analytics/metaPixel";

/** Initializes Meta Pixel and records the landing-page visit once. */
export function MetaPixel() {
  useEffect(() => {
    initializeMetaPixel();
  }, []);
  return null;
}